export default __webpack_public_path__ + "static/media/edit_on_over.9b289ee0.svg";